var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6217_7218)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 0V2H20V4H22V6H24V18H22V20H20V22H18V24H6V22H4V20H2V18H0V6H2V4H4V2H6V0H18Z",
    fill: "#1C0C3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.42871 6.14282V7.28568H8.57156V6.14282H7.42871Z",
    fill: "#CBBBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 6.14282V7.28568H13.1429V6.14282H12Z",
    fill: "#CBBBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5715 6.14282V7.28568H17.7144V6.14282H16.5715Z",
    fill: "#CBBBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.57153 7.28571H9.71439V8.42857H10.8573V7.28571H12.0001V6.14286H13.1429V5H10.8573V6.14286H8.57153V7.28571Z",
    fill: "#371D70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1431 7.28571H14.2859V8.42857H15.4288V7.28571H16.5716V6.14286H17.7145V5H15.4288V6.14286H13.1431V7.28571Z",
    fill: "#371D70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7144 7.28568H18.8572V6.14282H17.7144V7.28568Z",
    fill: "#371D70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7142 7.28577V15.2858H7.4285V7.28577H6.28564V16.4286H18.8571V7.28577H17.7142Z",
    fill: "#CBBBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8571 7.28571V16.4286H6.28571V7.28571H7.42857V6.14286H8.57144V5H6.28571V6.14286H5.14286V7.28571H4V18H20V7.28571H18.8571Z",
    fill: "#371D70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.42871 8.42862V15.2858H17.7144V7.28577H16.5716V8.42862H15.4287V9.57147H14.2859V8.42862H13.143V7.28577H12.0001V8.42862H10.8573V9.57147H9.71442V8.42862H8.57156V7.28577H7.42871V8.42862ZM10.8573 13.5715V10.7143H14.2859V11.8572H12.0001V13.0001H14.2859V14.1429H10.8573V13.5715Z",
    fill: "#9F7AF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.57153 8.42862H9.71439V7.28577H8.57153V8.42862Z",
    fill: "#CBBBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 8.42862V7.28577H10.8572V8.42862H12Z",
    fill: "#CBBBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1431 8.42862H14.2859V7.28577H13.1431V8.42862Z",
    fill: "#CBBBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5716 8.42862V7.28577H15.4287V8.42862H16.5716Z",
    fill: "#CBBBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.71436 9.57145H10.8572V8.42859H9.71436V9.57145Z",
    fill: "#CBBBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2856 9.57145H15.4285V8.42859H14.2856V9.57145Z",
    fill: "#CBBBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 14.1428H14.2858V13H12V11.8571H14.2858V10.7142H10.8572V14.1428H12Z",
    fill: "#371D70"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6217_7218"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWm);
export default __webpack_public_path__ + "static/media/WM.34a0de96d79ca31acd8739d2d7f1d973.svg";
export { ForwardRef as ReactComponent };